module.exports = __webpack_public_path__ + "img/20170319-7.4ceccd40.jpeg";